module.exports = __webpack_public_path__ + "img/Jalil.833a5747.jpeg";